<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-9">
            <span translate="Settings.IntegrationsAddressBookSection.Salesforce"></span>
        </h3>
    </div>
    <div class="p-4 pt-0">
        <form [formGroup]="configForm">
            <div class="mb-3 row-cols-md-12">
                <label for="SalesforceApiKey" class="form-label" translate="Settings.IntegrationsAddressBookSection.APIKey"></label>
                <input type="text" id="SalesforceApiKey" class="form-control" [value]="salesforceKey">
            </div>
            <div class="mb-3 col-12">
                <label for="SalesforceApiSecret" class="form-label" translate="Settings.IntegrationsAddressBookSection.APISecret"></label>
                <input type="text" id="SalesforceApiSecret" class="form-control" [value]="salesforceSecret">
            </div>
            <div class="mb-3 col-12">
                <label for="SalesforceApiSubdomain" class="form-label" translate="Settings.IntegrationsAddressBookSection.SalesforceSubdomain"></label>
                <div class="input-group col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
                    <input type="text" id="SalesforceApiSubdomain" class="form-control rounded-2" aria-label="SalesforceApiSubdomain" [value]="salesforceSubdomain">
                    <div class="input-group-append border-0">
                        <span class="input-group-text text-end border-0 me-0 ps-2 pe-0 bg-transparent" translate="Settings.IntegrationsAddressBookSection.SalesforceSubdomainURL"></span>
                    </div>
                </div>
            </div>
        </form>

        <div class="col-12 mt-4 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="closeCurrentModal()" translate>Button.Back</button></span>
            <span class="float-end"><button type="button" class="btn btn-sm btn-primary" (click)="save()" translate>Button.SaveChanges</button></span>
        </div>
    </div>    
</div>